module.exports = __webpack_public_path__ + "img/gold_vip_intro.1479443f.png";